<template>
    <div class="gz-page-title">
        <span>{{ title }}</span>
    </div>
</template>

<script>
export default {
    name: 'PageTitle',

    props: {
        title: {
            type: String
        }
    }
}
</script>